import { Button, Field, Input } from '@/components/ui'
import { useState, type FormEvent } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/auth/AuthContext'
import { setPassword } from '@/auth/api'
import { ApiError } from '@/api/client'

/**
 * /set-password?token=... — первый вход владельца по ссылке из письма-приглашения
 * (клуб подключён из Help). Пароль задаёт сам человек; ссылка одноразовая, после
 * успеха сразу открывается сессия.
 */
export function SetPassword(): React.JSX.Element {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const { loginWithSession } = useAuth()
  const token = params.get('token') ?? ''

  const [password, setPwd] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(
    token ? null : 'Ссылка неполная — откройте её из письма целиком'
  )
  const [loading, setLoading] = useState(false)

  async function onSubmit(e: FormEvent): Promise<void> {
    e.preventDefault()
    if (password.length < 6) return setError('Пароль не короче 6 символов')
    if (password !== confirm) return setError('Пароли не совпадают')
    setError(null)
    setLoading(true)
    try {
      const { token: jwt, staff } = await setPassword(token, password)
      loginWithSession(jwt, staff)
      navigate('/', { replace: true })
    } catch (err) {
      setError(
        err instanceof ApiError && err.message
          ? err.message
          : 'Не удалось сохранить пароль. Попробуйте позже.'
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth">
      <form className="auth__card" onSubmit={(e) => void onSubmit(e)}>
        <div className="auth__brand">
          <div className="auth__mark">8</div>
          <div className="auth__title">8Ball Бекофис</div>
          <div className="auth__sub">Задайте пароль для входа</div>
        </div>

        <Field label="Новый пароль" htmlFor="password">
          <Input
            id="password"
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPwd(e.target.value)}
            required
            autoFocus
            disabled={!token}
          />
        </Field>

        <Field label="Повторите пароль" htmlFor="confirm">
          <Input
            id="confirm"
            type="password"
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            disabled={!token}
          />
        </Field>

        {error && <div className="form-error">{error}</div>}

        <div className="field">
          <Button variant="primary" block type="submit" disabled={loading || !token}>
            {loading ? <span className="spin" /> : null}
            {loading ? 'Сохраняем…' : 'Сохранить и войти'}
          </Button>
        </div>
      </form>
    </div>
  )
}
